import { createI18n } from 'vue-i18n'
import zhCn from './locales/zh-cn'
import zhTw from './locales/zh-tw'
import en from './locales/en'

// 从 localStorage 获取保存的语言设置，默认为中文
const getLocale = () => {
  const savedLocale = localStorage.getItem('locale')
  return savedLocale || 'zh-cn'
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getLocale(), // 当前语言
  fallbackLocale: 'zh-cn', // 回退语言
  messages: {
    'zh-cn': zhCn,
    'zh-tw': zhTw,
    'en': en
  },
  globalInjection: true // 全局注入 $t 方法
})

export default i18n

